import CustomerModel from '../../../../../components/Customers/CustomerModel';
import ConversationModelMC from '../../../../models/inbox/ConversationModelMC';

export const buildDocumentsApiAdapter = ({ source, customerId }) => {
  if (source === 'inbox') {
    return {
      list: () => ConversationModelMC.getCustomerDocuments({ customerId }),
      upload: (file) => ConversationModelMC.uploadCustomerDocument({ customerId, file }),
      destroy: (documentId) => ConversationModelMC.deleteCustomerDocument({ customerId, documentId })
    };
  }

  return {
    list: () => CustomerModel.getDocuments({ customerId }),
    upload: (file) => CustomerModel.uploadDocument({ customerId, file }),
    destroy: (documentId) => CustomerModel.deleteDocument({ customerId, documentId })
  };
};
